export enum SvcDialogMode {
  add,
  view,
  edit,
}
